export const FETCH_POSTS = 'FETCH_POSTS';
export const NEW_POST = 'NEW_POST';
export const KEY_PRESS = 'KEY_PRESS';
export const CHANGE_DIFFUCULTY = 'CHANGE_DIFFUCULTY';
export const ADD_LETTER = 'ADD_LETTER';
export const REMOVE_LETTER = 'REMOVE_LETTER';
export const INC_COUNT = 'INC_COUNT';
export const DEC_COUNT = 'DEC_COUNT';
export const EASY = {width:5,height:7, name: 'easy'};
export const MEDIUM = {width:6,height:6, name: 'medium'};
export const HARD = {width:7,height:5, name: 'hard'};
export const BLOCK_INPUT = 'BLOCK_INPUT';
export const UNBLOCK_INPUT = 'UNBLOCK_INPUT';
export const RESET_BOX_COLOR = 'RESET_BOX_COLOR';
export const CHANGE_BOX_CLASSNAME_IN_RANGE = 'CHANGE_BOX_CLASSNAME_IN_RANGE'; 
export const INC_ROW = 'INC_ROW';
export const TOO_SHORT_ERR = ('TOO_SHORT_ERR');
export const CLEAR_TOO_SHORT_ERR = ('CLEAR_TOO_SHORT_ERR');
export const INVALID_WORD_ERR = ('INVALID_WORD_ERR');
export const CLEAR_INVALID_WORD_ERR = ('CLEAR_INVALID_WORD_ERR');
export const CHANGE_ANSWER = 'CHANGE_ANSWER';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const SET_WORD_ARRAY_SIZE = 'SET_WORD_ARRAY_SIZE';
export const SET_BOX_ARRAY = 'SET_BOX_ARRAY';
export const RESET_LETTER_COUNT = 'RESET_LETTER_COUNT';
export const RESET_ROW_COUNT = 'RESET_ROW_COUNT';
export const SET_GAME_OVER = 'SET_GAME_OVER';
export const SET_GAME_START = 'SET_GAME_START';
export const SET_WIN_CONDITION = 'SET_WIN_CONDITION';
export const RESET_SET_WIN_CONDITION = 'RESET_SET_WIN_CONDITION';
export const CHANGE_KEY_COLOR = 'CHANGE_KEY_COLOR'
export const RESET_KEYBOARD = 'RESET_KEYBOARD'